import { Alert, Card, Grid, Switch, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import React, { useState } from 'react';
import {
    useGetPreferencesQuery,
    useUpdatePreferencesMutation,
} from '../../api/authApiSlice';
import Screen from '../../components/fragments/Screen';
import errorSnackbar from '../../utils/errorSnackbar';

export default function NotificationSettingsScreen() {
    const { enqueueSnackbar } = useSnackbar();
    const [updatePreferences] = useUpdatePreferencesMutation();
    const { data: { data: preferences } = {} } = useGetPreferencesQuery(null, {
        refetchOnMountOrArgChange: true,
    });

    const onSettingClicked = async (setting) => {
        const newPreferences = { ...preferences, [setting.key]: setting.value };
        const { error, data: update } = await updatePreferences(newPreferences);
        errorSnackbar(error, enqueueSnackbar);
        if (update) enqueueSnackbar('Updated successfully');
    };

    const defaultPermission = window.Notification.permission;

    return (
        <Screen title={'Notifications'}>
            <Grid item xs={12}>
                <Alert
                    style={{ width: '100%' }}
                    severity={
                        'info' ||
                        (defaultPermission === 'granted' ? 'success' : 'danger')
                    }
                >
                    Notification Permisions are{' '}
                    <span className="fw-bold">{defaultPermission}</span>
                </Alert>
            </Grid>
            {preferences &&
                Object.entries(preferences).map(([key, value]) => (
                    <Setting
                        key={key}
                        setting={{ key, value }}
                        onSettingClicked={onSettingClicked}
                    />
                ))}
        </Screen>
    );
}

const Setting = ({ setting, onSettingClicked }) => {
    const [checked, setChecked] = useState(setting.value);

    return (
        <Grid item xs={12}>
            <Card variant="outlined" style={{ borderWidth: 2 }}>
                <div
                    style={{ margin: 12 }}
                    className="d-flex flex-row align-items-center justify-content-between"
                >
                    <Typography
                        color="textPrimary"
                        style={{ fontWeight: 'bold' }}
                        noWrap={false}
                        className="text-capitalize"
                    >
                        {setting.key}
                    </Typography>
                    <Switch
                        checked={checked}
                        onClick={() => {
                            onSettingClicked({
                                ...setting,
                                value: !setting.value,
                            });
                            setChecked(!checked);
                        }}
                    />
                </div>
            </Card>
        </Grid>
    );
};
